var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6667 5.68016V2.6535C14.6667 1.7135 14.24 1.3335 13.18 1.3335H10.4867C9.42667 1.3335 9 1.7135 9 2.6535V5.6735C9 6.62016 9.42667 6.9935 10.4867 6.9935H13.18C14.24 7.00016 14.6667 6.62016 14.6667 5.68016Z",
    fill: "#F9FBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z",
    fill: "#F9FBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 5.68016V2.6535C7.00065 1.7135 6.57398 1.3335 5.51398 1.3335H2.82065C1.76065 1.3335 1.33398 1.7135 1.33398 2.6535V5.6735C1.33398 6.62016 1.76065 6.9935 2.82065 6.9935H5.51398C6.57398 7.00016 7.00065 6.62016 7.00065 5.68016Z",
    fill: "#F9FBFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.00065 13.18V10.4867C7.00065 9.42667 6.57398 9 5.51398 9H2.82065C1.76065 9 1.33398 9.42667 1.33398 10.4867V13.18C1.33398 14.24 1.76065 14.6667 2.82065 14.6667H5.51398C6.57398 14.6667 7.00065 14.24 7.00065 13.18Z",
    fill: "#F9FBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.052834db5066464dc37c33906e612c12.svg";
export { ForwardRef as ReactComponent };